import React, { useState, useEffect } from 'react';
import { Provider } from 'mobx-react';
import { Router, RouterStore } from 'react-router-mobx';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';
import RootStore from 'stores';
import layoutStyle from './routes/style.module.scss';
import './style/index.scss';
import { ModalComponent } from 'components/modal';
import PromptContainer from './components/prompt/container';
import Routes from './routes';
import TagManager from 'react-gtm-module/dist/TagManager';
import setCssVariables from './hooks/useCssVariable';
import mainHost from './hooks/useHost';

const rootStore = new RootStore();
const routerStore = new RouterStore();

// TagManager.initialize({ gtmId: 'GTM-MQM6LNV' });

window.addEventListener('message', function (event) {
  if (event.data.commend === 'opener_reload_after_login') {
    window.location.reload();
  }
});

function App() {
  const [store, setStore] = useState(rootStore);

  // Set CSS variables for icons and images
  useEffect(() => {
    const host = mainHost();
    setCssVariables({
      'sport-main-icon': `url('https://image.${host}/portal/new_sp_main_icons.png')`,
      'sport-attend-icon': `url('http://${host}/img/page/attend/sp_attend_v15031117.png')`,
      'sport-attend-icon-gif': `url('http://${host}/img/page/attend/bg_attend_v15031117.gif')`,
    });
  }, []);

  return (
    <Provider {...store}>
      <ModalComponent />
      <Router component={BrowserRouter} routerStore={routerStore}>
        <div className={layoutStyle.projectWrapper}>
          <Routes />
          {/*<DebuggingMenu />*/}
        </div>
      </Router>
      <PromptContainer />
    </Provider>
  );
}

export default App;

const DebuggingMenu = () => {
  if (process.env.REACT_APP_API === 'production' || window.opener !== null) {
    return null;
  } else {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          height: 48,
          width: '100%',
          backgroundColor: '#000',
        }}
      >
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/live'>
          벳블LIVE
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/major'>
          주요경기
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/soccer'>
          축구
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/baseball'>
          야구
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/basketball'>
          농구
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/volleyball'>
          배구
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/hockey'>
          하키
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/football'>
          미식축구
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/lol'>
          롤
        </Link>
        <Link style={{ color: '#fff', fontSize: 14, marginRight: 12 }} to='/starcraft'>
          스타
        </Link>
      </div>
    );
  }
};
